import mod from "-!../../../node_modules/babel-loader/lib/index.js!./mortgage.js?vue&type=script&lang=js&"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!./mortgage.js?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/components/mortgage/mortgage.js?vue&type=script&lang=js&
// module id = 30
// module chunks = 0